import { useApp } from "@/context/AppContext";

export default function CookieBanner() {
  const { cookieAccepted, acceptCookies, t } = useApp();
  if (cookieAccepted === "yes" || cookieAccepted === "no") return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 inset-x-4 md:left-auto md:right-4 md:max-w-md z-[60] bg-[#0F0F0F] border border-white/15 shadow-2xl p-5 text-sm">
      <p className="text-white/85 leading-relaxed mb-4">{t("cookie_msg")}</p>
      <div className="flex gap-2 justify-end">
        <button onClick={() => acceptCookies(false)} data-testid="cookie-decline" className="btn-outline !px-4 !py-2 !text-[11px]">{t("cookie_decline")}</button>
        <button onClick={() => acceptCookies(true)} data-testid="cookie-accept" className="btn-gold !px-4 !py-2 !text-[11px]">{t("cookie_accept")}</button>
      </div>
    </div>
  );
}
